import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00d83d9b&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d83d9b')) {
      api.createRecord('00d83d9b', component.options)
    } else {
      api.reload('00d83d9b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00d83d9b&", function () {
      api.rerender('00d83d9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firstOrder/index.vue"
export default component.exports